export const wordsDevices = [
"Мо|нитор",
"Про|цессор",
"Па|мять",
"Жёсткий|диск",
"Кла|виша",
"Микро|фон",
"Клави|атура",
"Кур|сор",
"Флеш|ка",
"Науш|ники",
"Ска|нер",
"Веб-|камера",
"Ко|лонки",
"Венти|лятор",
"Прин|тер",
"Мы|шь",
"Проек|тор"];